if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.currentVariant = null;
      this.cartesian = null;
      this.areAllSelectionsMade = false;
      this.qtyLabel = this.dataset.qtyLabel;
      this.qtyLabelPlural = this.dataset.qtyLabelPlural;
    }
    
    connectedCallback() {
      this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale   
      this.cartesian = JSON.parse(this.querySelector('template[data-cartesian]')?.content.textContent ?? '[]');
      this.atcButton = this.querySelector('[data-action="add-to-cart"]');
      this.form = this.querySelector(`form[action="${this.locale ? `/${this.locale}` : `` }/cart/add"]`);            
      if (!this.cartesian) return;
            
      this.currentVariant = this.cartesian[this.getCurrentOptionSet().toString()] || null;
      this.calculateAvailability();
      
      this.querySelector('[name="quantity"]').addEventListener('change', () => this.updatePriceDisplay());
            
      this.addEventListener('change', e => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
          imageSwap,
          titleSwap,
          optionName,
          option
        } = clickedElement.dataset;
                
        switch (action) {
          case 'option-choice':
            this.currentVariant = this.cartesian[this.getCurrentOptionSet().toString()];
            if (!this.currentVariant) return;
            
            document.querySelectorAll('[data-show]').forEach((el) => {
              if (Number(el.dataset.show) === Number(this.currentVariant.variant_json.id)) {
                el.style.display = null;

                // Re-measure any swipers that initialized while hidden (0px dimensions).
                el.querySelectorAll('[data-swiper-loop]').forEach(function (swiperEl) {
                  if (!swiperEl.swiper) return;
                  requestAnimationFrame(function () {
                    swiperEl.swiper.update();
                    swiperEl.swiper.loopDestroy();
                    swiperEl.swiper.loopCreate();
                    swiperEl.swiper.slideToLoop(swiperEl.swiper.params.initialSlide || 0, 0);
                  });
                });

                if (el.dataset.qtyLabel) this.qtyLabel = el.dataset.qtyLabel;
                if (el.dataset.qtyLabelPlural) this.qtyLabelPlural = el.dataset.qtyLabelPlural;

                // Instantiate model-viewer on first selection of this variant
                const lazyTemplate = el.querySelector('template[data-lazy-model]');
                if (lazyTemplate) {
                  lazyTemplate.replaceWith(lazyTemplate.content.cloneNode(true));
                  const mv = el.querySelector('model-viewer');
                  if (mv) {
                    mv.removeAttribute('poster');
                    if (typeof attachPosterOverlayListener === 'function') attachPosterOverlayListener(mv);
                  }
                }

                return;
              }
              el.style.display = 'none';
            });
            this.calculateAvailability();
            this.updatePriceDisplay();
            this.updateUrlVariant();
            this.updateMatchedOptionVariant();
            
            const optionNameDisplay = this.querySelectorAll(`[data-option-name-display="${option}"]`);
            if (optionName) optionNameDisplay.forEach(el => el.innerText = optionName);
            
            if (titleSwap) {
              document.querySelectorAll('[data-variant-title]').forEach(el => {
                el.innerHTML = optionName.replace(' ', '<br>');
                if (el._blurIn) {
                  el._blurIn._split();
                  el._blurIn.replay();
                }
              });
            }
          break;
        }
      });
    }
    
    calculateAvailability() {
      if (this.currentVariant?.variant_json.available) {
        this.querySelector('[type="submit"][data-action="add-to-cart"]')?.removeAttribute('disabled');
      } else this.querySelector('[type="submit"][data-action="add-to-cart"]')?.setAttribute('disabled', true);
            
      this.classList.toggle('selection-needed', false);  

      if (!this.currentVariant) return;
      this.querySelector('select[name="id"]').value = this.currentVariant.variant_json.id;
    }
    
    updatePriceDisplay() {
      if (!this.currentVariant) return;
      const priceDisplays = document.querySelectorAll('[data-price]');     
      const qtyDisplays = document.querySelectorAll('[data-quantity-display]'); 
      const currentQty = Number(this.querySelector('[name="quantity"]')?.value);
      
      qtyDisplays.forEach((el) => {
        el.innerText = `${currentQty} ${currentQty > 1 ? this.qtyLabelPlural : this.qtyLabel}`;
      });
      
      
      priceDisplays.forEach((el) => {
        const priceCents = Number(this.currentVariant.variant_json.price);
        const compareAtCents = Number(this.currentVariant.variant_json.compare_at_price);

        let discountValue = 0;

        if (compareAtCents > priceCents && compareAtCents > 0) {
          const discountCents = compareAtCents - priceCents;
          discountValue = Math.round((discountCents * 100) / compareAtCents);
        }

        const compareAtPrice = Number(compareAtCents / 100);
        let fullPrice = Number(priceCents) / 100;
                
        el.innerHTML = `
          <span class="price ${compareAtPrice > fullPrice || bmpsPrice ? `text-cardinal` : ``}">
            ${this.dataset.currencySymbol}${bmpsPrice ? ((bmpsPrice / 100) * currentQty).toFixed(2) : (fullPrice * currentQty).toFixed(2)}
          </span>
          ${compareAtPrice > fullPrice || bmpsPrice ?`
            <span class="discount-price">
              ${this.dataset.currencySymbol}${(compareAtPrice * currentQty).toFixed(2)}
            </span>
            <span class="badge bg-cardinal !tracking-normal text-white text-sm md:text-base font-bold font-heading px-[9px] pt-1.5 pb-2 leading-none rounded text-center uppercase ">
              ${saveLabel} ${bmpsPrice ? percentageDiscount : discountValue}%
            </span>
          ` 
          : ''}
          
        `;
      return; 
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      const { variant_model_src, variant_media_src } = this.currentVariant;
      const { featured_image } = this.currentVariant.variant_json;
      const container = document.querySelector('[data-featured-media]');
      if (!container) return;

      if (variant_model_src) {
        container.innerHTML = `<model-viewer
          src="${variant_model_src}"
          ${featured_image?.src ? `poster="${featured_image.src}"` : ''}
          camera-controls
          auto-rotate
          style="width:100%;height:100%"
        ></model-viewer>`;
        if (!window._modelViewerUILoaded) {
          window._modelViewerUILoaded = true;
          Shopify.loadFeatures([{
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: (errors) => {
              if (errors) return;
              new Shopify.ModelViewerUI(container.querySelector('model-viewer'));
            }
          }]);
        }
      } else {
        const rawSrc = variant_media_src || featured_image?.src;
        if (!rawSrc) return;
        const size = window.innerWidth > 768 ? '_800x' : '_500x';
        const newSrc = rawSrc.replace(/\.([a-z]{3,4})(\?.*)?$/, `${size}.$1`);
        const img = container.querySelector('[data-featured="true"]');
        if (img) {
          img.setAttribute('src', newSrc);
          img.setAttribute('srcset', '');
        } else {
          container.innerHTML = `<img data-featured="true" src="${newSrc}" srcset="">`;
        }
      }
    }
    
    updateUrlVariant() {
      if (!this.currentVariant) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', this.currentVariant.variant_json.id);
      window.history.replaceState({}, '', url);
    }
    
    updateMatchedOptionVariant() {
      this.querySelectorAll('[data-matched-option-variant]').forEach((swatchImage) => {
        const { dataset: { matchedOptionVariant, position }} = swatchImage;
        const matchedVariant = this.getMatchingVariant(position, matchedOptionVariant);
        if (!matchedVariant) return;
        swatchImage.src = matchedVariant.variant_json.featured_image.src;
      })
    }

    getCurrentOptionSet(position, option) {
      let thisOptionSet;
        thisOptionSet = [...this.querySelectorAll('select[data-action="option-choice"], [data-action="option-choice"]:checked')].map(({ value }) => value);
      if (position && option) {
        const optionIndex = Number(position) - 1;
        thisOptionSet[optionIndex] = option;
      }
      return thisOptionSet;
    }
    
    getMatchingVariant(position, option) {
      const optionIndex = Number(position) - 1;
      let thisOptionSet = this.getCurrentOptionSet();
      thisOptionSet[optionIndex] = option;
      return this.cartesian[thisOptionSet.toString()]
    }
  }
  
  customElements.define('product-form', ProductForm);
}
